import { ClientDataType, Combinator } from '../types';
import { createBlankCondition } from './createBlankCondition';
import { createBlankCriteria } from './createBlankCriteria';
import { createBlankRequirement } from './createBlankRequirement';

/**
 * criteria for catalog contains a blank condition unlike User and Event
 */
export const createBlankCriteriaForCatalog = (combinator: Combinator) =>
  createBlankCriteria({
    combinator,
    searchQueries: [
      createBlankRequirement({
        dataType: ClientDataType.User,
        searchCombo: {
          combinator: Combinator.AND,
          searchQueries: [createBlankCondition(ClientDataType.User)],
        },
      }),
    ],
  });
